export default __webpack_public_path__ + "files/media/hd-private.eca4da5e.jpg";